var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenseSolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50017 1.25C3.9814 1.25 2.75018 2.4812 2.75017 3.99998L2.75003 20C2.75002 21.5188 3.98124 22.75 5.50003 22.75H18.5C20.0188 22.75 21.25 21.5188 21.25 20V4C21.25 2.48122 20.0188 1.25 18.5 1.25H5.50017ZM8.00003 6C7.44775 6 7.00003 6.44772 7.00003 7C7.00003 7.55228 7.44775 8 8.00003 8H16C16.5523 8 17 7.55228 17 7C17 6.44772 16.5523 6 16 6H8.00003ZM8.00003 11C7.44775 11 7.00003 11.4477 7.00003 12C7.00003 12.5523 7.44775 13 8.00003 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H8.00003ZM8.00003 16C7.44775 16 7.00003 16.4477 7.00003 17C7.00003 17.5523 7.44775 18 8.00003 18H12C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16L8.00003 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseSolidStandard);
export default __webpack_public_path__ + "static/media/license-solid-standard.1e9130960188c3a6347a6c7105a618ba.svg";
export { ForwardRef as ReactComponent };